import PropTypes from 'prop-types';
import styles from './newCustomInput.module.css';
import { useEffect, useRef } from 'react';

const NewCustomInputText = ({ label, name, type, value, onChange, placeholder, required, error, language }) => {
  const textareaRef = useRef(null);
  useEffect(() => {
      if (type === 'textarea' && textareaRef.current) {
        const textarea = textareaRef.current;
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    }, [type, value]);

    const getDirection = (text) => {
      const rtlChars = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
      return rtlChars.test(text) ? "rtl" : "ltr";
    };
  
    const isUrdu = language === "Urdu";
    const dir = isUrdu ? "rtl" : getDirection(value || "");
  
  
  return (
    <div className="mb-1">
      <div className={styles.input__wrapper}>
        <textarea
          ref={textareaRef}
          type={type}
          id={name} // Added to link with label's htmlFor
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          title={label}
          required={required}
          rows="10"
          dir={dir}
          className={`${styles.input__field} ${dir === "rtl" ? "text-right" : "text-left"} w-full px-3 py-2 bg-white ${error ? 'border-red-500 focus:ring-red-500' : ''}`}
        />
        <label htmlFor={name} className={styles.input__label}>
          {label}
        </label>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

NewCustomInputText.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
};

NewCustomInputText.defaultProps = {
  type: 'text',
  value: '',
  placeholder: '',
  error: null,
  required: false,
};

export default NewCustomInputText;